import { mutator } from 'satcheljs';
import { addPill, removePill, clearPills } from '../actions/pillActions';
import getStore from '../store/store';

export const addPillMutator = mutator(addPill, actionMessage => {
    const { allAddedPills, viewState } = getStore();
    const newPill = actionMessage.pillData;

    let foundIndex = -1;
    allAddedPills.forEach((value, index) => {
        if (value.id === newPill.id) {
            foundIndex = index;
        }
    });
    if (foundIndex !== -1) {
        allAddedPills[foundIndex] = newPill;
    } else {
        allAddedPills.push(newPill);
    }

    if (!viewState.barVisible) {
        viewState.barVisible = true;
    }
});

export const removePillMutator = mutator(removePill, actionMessage => {
    const store = getStore();
    store.allAddedPills = store.allAddedPills.filter(value => {
        return value.id != actionMessage.pillId;
    });
});

export const clearPillsMutator = mutator(clearPills, actionMessage => {
    const store = getStore();
    while (store.allAddedPills.length > 0) {
        store.allAddedPills.pop();
    }
});
